import {useTranslation} from '@aboutyou/i18n';
import {useHistory, useWishlistRoute} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {GenericIconName} from '@aboutyou/ui-components';
import {useWishlistBubbleColour, useWishlistCount} from '@aboutyou/user';
import React, {useMemo} from 'react';
import {IconMetaNavigationItem} from './IconMetaNavigationItem';

export const IconMetaNavigationItemWishlist: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({onClick}) => {
  const {t} = useTranslation();
  const wishlistCount = useWishlistCount().count;
  const trackFeature = useTrackFeature();
  const wishlistRoute = useWishlistRoute();
  const history = useHistory();
  const bubbleColour = useWishlistBubbleColour();

  const saleIndication = useMemo(() => {
    if (bubbleColour) {
      return {color: bubbleColour.hex};
    }
    return undefined;
  }, [bubbleColour]);

  return (
    <IconMetaNavigationItem
      dataTestId="Wishlist"
      icon={GenericIconName.NavHeaderWishlist}
      label={t('Wishlist')}
      count={wishlistCount}
      badgeOffset={{
        right: 0,
        top: 2,
      }}
      saleIndication={saleIndication}
      onClick={event => {
        onClick(event);
        trackFeature({eventType: 'click', label: 'wishlist_icon'});
        history.push(wishlistRoute);
      }}
    />
  );
};
